import { render, staticRenderFns } from "./KDSOrder.vue?vue&type=template&id=84b5b01c&scoped=true"
import script from "./KDSOrder.vue?vue&type=script&lang=js"
export * from "./KDSOrder.vue?vue&type=script&lang=js"
import style0 from "./KDSOrder.vue?vue&type=style&index=0&id=84b5b01c&prod&scoped=true&lang=scss"
import style1 from "./KDSOrder.vue?vue&type=style&index=1&id=84b5b01c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b5b01c",
  null
  
)

export default component.exports